<template>
  <MGuidedCheckoutStep
    step-number="2"
    title="Wie groß ist dein Projekt?"
    description="Gib deine Projektfläche an, damit wir die benötigte Paketmenge inklusive Verschnitt für dich berechnen."
  >
    <div class="product__buy-box m-gc-step-size__box">
      <div class="product__buy-box__inner">
        <div class="badge badge-gray">
          Menge wählen
        </div>

        <AProductQuantityCalculator
          v-if="mainOptionValue && mainOptionValue.product"
          :value="quantity"
          :product="mainOptionValue.product"
          :show-offcuts="true"
          unlimit-quantity
          @input="updateQuantity"
        />
      </div>
    </div>
  </MGuidedCheckoutStep>
</template>

<script>
import MGuidedCheckoutStep from 'theme/components/molecules/guided-checkout/m-guided-checkout-step'
import AProductQuantityCalculator from 'theme/components/atoms/a-product-quantity-calculator'
import {
  getMainBundleOption,
  setMainBundleQuantity
} from 'theme/helpers/guided-checkout'
import { getSelectedBundleOptionValue } from 'theme/helpers/bundle'

export default {
  name: 'MGcStepSize',
  components: {
    MGuidedCheckoutStep,
    AProductQuantityCalculator
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    quantity: {
      type: Number,
      default: 1
    },
    bundleOptionsComponent: {
      type: Object,
      default: null
    }
  },
  computed: {
    mainOption () {
      return getMainBundleOption(this.product)
    },
    mainOptionValue () {
      return this.mainOption
        ? getSelectedBundleOptionValue(this.product, this.mainOption)
        : null
    }
  },
  methods: {
    updateQuantity (quantity) {
      this.$emit('input', quantity)
      this.$emit('changed', quantity)
      this.$nextTick(() => {
        setMainBundleQuantity(this.bundleOptionsComponent, this.product, quantity)
      })
    }
  }
}
</script>
